<template>
  <div>
    <div class="pop_ul scrollBar" :style="{ height: bodyHeight - 60 + 'px' }">
      <div v-for="(val, key) in list" :key="key">
        <div class="Contacts_tit">
          {{ val.first_char ? val.first_char : "##" }}
        </div>
        <div
          :class="pop.id == vala.id ? 'Contacts_li mr' : ' Contacts_li'"
          @click="getright(vala)"
          v-for="(vala, keya) in val.list"
          :key="keya"
        >
          <div>
            <img
              :src="
                vala.avatar
                  ? `data:image/png;base64,${vala.avatar}`
                  : require('@/assets/img/my_avatar.png')
              "
              alt=""
            />
          </div>
          {{ vala.name ? vala.name : vala.mobile }}
        </div>
      </div>
      <div class="noData" v-if="list.length <= 0 && status">{{$t('contacts.no')}}</div>
    </div>
    <div
      id="dialog"
      v-if="pop.id"
      :style="{ width: bodyWidth - 681 + 'px', height: bodyHeight - 60 + 'px' }"
    >
      <div class="name">{{ pop.name ? pop.name : pop.mobile }}</div>
      <div class="dialog_img">
        <img
          :src="
            pop.avatar
              ? `data:image/png;base64,${pop.avatar}`
              : require('@/assets/img/my_avatar.png')
          "
        />
      </div>
      <div class="dialog_name">{{ pop.name ? pop.name : pop.mobile }}</div>
      <div class="dialog_num">
        <img src="@/assets/img/c.png" />
        <div class="dialog_num_t">{{$t('contacts.numbers')}}</div>
        <div class="dialog_num_c">{{ pop.mobile }}</div>
      </div>
      <div class="dialog_num">
        <img src="@/assets/img/e.png" />
        <div class="dialog_num_t">{{$t('contacts.emails')}}</div>
        <div class="dialog_num_c">{{ pop.email }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Concat } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      list: [],
      pop: {
        avatar: null,
        createtime: '',
        email: null,
        equipment_id: '',
        first_char: null,
        id: null,
        mobile: '',
        name: null,
        updatetime: null,
        user_id: 2
      },
      bodyHeight: document.body.clientHeight || window.innerHeight,
      bodyWidth: document.body.clientWidth || window.innerWidth,
      msg: '',
      status: null
    }
  },
  mounted () {
    this.handleCommand()
  },
  methods: {
    handleCommand () {
      Concat({ equipment_id: localStorage.getItem('systemId') }).then((adj) => {
        this.list = adj.data
        this.status = 1
        this.getright(this.list[0].list[0])
      })
    },
    getright (adj) {
      console.log(adj)
      this.pop = adj
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pop_ul {
  float: left;
  /* width: 385px; */
  width: 419px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  overflow: auto;
}

.Contacts_tit {
  background: #f1f3f5;
  line-height: 20px;
  padding: 10px 0 5px;
  font-size: 14px;
  color: #000;
  font-weight: 700;
  text-indent: 40px;
}
.Contacts_li {
  height: 24px;
  line-height: 24px;
  padding: 18px 0;
  border-bottom: 1px solid #e1e3e6;
  font-size: 14px;
  color: #000927;
  font-weight: 700;
}
.Contacts_li.mr {
  background: rgba(0, 238, 195, 0.1);
}
.Contacts_li div {
  width: 24px;
  height: 24px;
  float: left;
  margin: 0 15px 0 40px;
  border-radius: 12px;
  overflow: hidden;
}
.Contacts_li div img {
  width: 24px;
  height: 24px;
  float: left;
}
#dialog {
  position: fixed;
  top: 60px;
  right: 0;
  background: #fff;
}
#dialog .name {
  width: 100%;
  height: 77px;
  line-height: 77px;
  border-bottom: 1px solid #e1e3e6;
  font-size: 16px;
  color: #000927;
  font-weight: 700;
  text-indent: 40px;
}
.dialog_img {
  width: 88px;
  border: 2px solid #f6f8fa;
  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  margin: 100px auto 0;
  overflow: hidden;
  height: 88px;
  border-radius: 50%;
}
.dialog_img img {
  width: 100%;
  height: 100%;
}
.dialog_name {
  margin: 0 auto;
  width: 400px;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  color: #000927;
  text-align: center;
  font-weight: 700;
}
.dialog_num {
  margin: 20px auto 0;
  width: 400px;
  border: 1px solid #e1e3e6;
  border-radius: 12px;
  overflow: hidden;
  padding: 25px 0;
}
.dialog_num img {
  display: block;
  width: 40px;
  height: 40px;
  float: left;
  margin: 0 16px;
}
.dialog_num div {
  font-size: 13px;
  color: #9f9f9f;
  font-weight: 400;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue